(() => {
  if (window.ilsRetiredOfferCleanup) return;
  window.ilsRetiredOfferCleanup = true;
  const products = ['vion', 'ardews', 'loravo', 'vayen'];
  const fields = ['experiment__', 'group__', 'visitor__', 'theme__', 'event_ticket__'];
  const attributes = {};
  for (const product of products) {
    for (const field of fields) attributes[`ils_${product}_${field}`] = '';
    try {
      localStorage.removeItem(`ils-${product}-rollout-tracking`);
      localStorage.removeItem(`ils-${product}-rollouts-${product === 'vion' ? 400 : 300}-1h-v1`);
    } catch {}
  }
  try { localStorage.removeItem('ils-vion-grey-400-1h-v1'); } catch {}
  // Private cart attributes cannot be inspected through cart.js. Clear only the
  // retired experiment's exact keys; preserve products, notes and other attributes.
  fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    credentials: 'same-origin',
    body: JSON.stringify({attributes}),
    keepalive: true
  }).catch(() => {});
})();
